import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { useLanguage } from '@/context/LanguageContext';
import { buildStoredTenantAppUrl, getStoredTenantAppOrigin } from '@/lib/postLoginRedirect';

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading } = useAuth();
  const { pathFor } = useLanguage();
  const location = useLocation();
  const tenantRedirectUrl = buildStoredTenantAppUrl(location.pathname, location.search, location.hash);
  const shouldRedirectToTenant =
    Boolean(isAuthenticated) &&
    Boolean(tenantRedirectUrl) &&
    typeof window !== 'undefined' &&
    getStoredTenantAppOrigin() !== window.location.origin;

  useEffect(() => {
    if (!shouldRedirectToTenant) return;
    window.location.replace(tenantRedirectUrl);
  }, [shouldRedirectToTenant, tenantRedirectUrl]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-gray-600">
        Checking session...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={pathFor('/signin')} replace state={{ from: location }} />;
  }

  if (shouldRedirectToTenant) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-gray-600">
        Redirecting to your workspace...
      </div>
    );
  }

  return children;
}
